import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PbxDid } from 'voxloud-types/dist/models';
import { DidsService } from 'src/app/domains/dids/services';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';

@Component({
  selector: 'gdp-change-outbound-did-popup',
  templateUrl: './change-outbound-did-popup.component.html',
  styleUrls: ['./change-outbound-did-popup.component.scss']
})
export class ChangeOutboundDidPopupComponent implements OnInit {

  @Input() currentDid: string;
  @Input() pbxId: number;
  public selectedDid: PbxDid;
  public didsList: PbxDid[] = [];
  public isDidsListLoading = false;

  constructor(private activeModal: NgbActiveModal, private didsService: DidsService, private notification: NotificationService) { }

  ngOnInit() {
    this.isDidsListLoading = true;
    this.didsService.getDidsByPbx(this.pbxId).subscribe(
      (response) => {
        this.didsList = response;
        this.selectedDid = this.didsList.find(did => did.number === this.currentDid);
        this.isDidsListLoading = false;
      }, () => {
        this.isDidsListLoading = false;
      }
    );
  }

  onSelectDid(did: PbxDid) {
    this.selectedDid = did;
  }

  emitSave() {
    this.activeModal.close(this.selectedDid.number);
  }

  close() {
    this.activeModal.close(null);
  }

}
